import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  content
}: LegalModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-59">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm" data-id="element-60" />

          {/* Modal Container */}
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6 pointer-events-none" data-id="element-61">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          type: 'spring',
          duration: 0.5
        }} className="w-full max-w-2xl max-h-[85vh] flex flex-col bg-[#FDF8F0] border border-[#E8DDD0] rounded-2xl shadow-2xl pointer-events-auto" data-id="element-62">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-[#E8DDD0]" data-id="element-63">
                <h2 className="text-xl font-semibold text-[#2A6B6B] font-serif" data-id="element-64">
                  {title}
                </h2>
                <button onClick={onClose} className="p-2 text-[#5C544E] hover:text-[#3D3631] hover:bg-[#E8DDD0]/50 rounded-full transition-colors" aria-label="Cerrar" data-id="element-65">
                  <X className="w-5 h-5" data-id="element-66" />
                </button>
              </div>

              {/* Scrollable Content */}
              <div className="overflow-y-auto p-6 text-[#5C544E] space-y-4 leading-relaxed" data-id="element-67">
                {content}
              </div>

              {/* Footer */}
              <div className="p-6 border-t border-[#E8DDD0] bg-white/50 rounded-b-2xl" data-id="element-68">
                <button onClick={onClose} className="w-full sm:w-auto px-6 py-2.5 bg-[#2A6B6B] hover:bg-[#1F5555] text-white rounded-lg transition-colors font-medium text-sm" data-id="element-69">
                  Cerrar
                </button>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}